import { render } from "./PrevBtn.vue?vue&type=template&id=4f2dfe8d&ts=true"
import script from "./PrevBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrevBtn.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/PrevBtn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f2dfe8d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f2dfe8d', __exports__)) {
    api.reload('4f2dfe8d', __exports__)
  }
  
  module.hot.accept("./PrevBtn.vue?vue&type=template&id=4f2dfe8d&ts=true", () => {
    api.rerender('4f2dfe8d', render)
  })

}


export default __exports__